import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import './FeatureBox.css';

const FeatureBox = ({ icon: Icon, title, description }) => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.2 });

  return (
    <div
      ref={ref}
      className={`feature-box fade-in-section ${isVisible ? 'is-visible' : ''}`}
    >
      <div className="feature-box-icon">
        <Icon />
      </div>
      <h4 className="feature-box-title">{title}</h4>
      <p className="feature-box-description">{description}</p>
    </div>
  );
};

export default FeatureBox;
